import { formatWithTimezone } from 'src/libs/util'
import React, { useState } from 'react'
import useGetWithContext from 'src/hooks/useGetWithContext'
import { UsernameById1 } from './UsernameById'
import { useTranslation } from 'next-i18next'

export function SimpleNotesHtkt ({ notes, removeTime, isBreak, isHtmlComment }) {
  const { t } = useTranslation()
    const [showMore, setShowMore] = useState(false)
  const replaceWithBr = (comment) => {
    return comment.replace(/\n/g, '<br />')
  }

  if (!notes?.length) return null

  const noteList = notes.map((note, idx) => {
    const { userId, comment, time, color: textColor, errorType, status } = note || {}
    let noteColor = ''
    if (textColor === 'RED') noteColor = 'text-danger'
    if (!comment || !userId) return null
    const user = <UsernameById1 useHook={useGetWithContext} id={userId} />
    return (
      <React.Fragment key={idx}>
        <div className='simple-note-item mb-2' style={{ textAlign: 'justify' }}>
          <span className='text-secondary' style={{ whiteSpace: 'nowrap' }}>
            {user}{': '}
            {!removeTime && time
              ? `${formatWithTimezone(time, 'HH:mm dd/MM/yyyy')}`
              : null}<br />
          </span>
          <>
            {errorType ? t(`constant.error_type.${errorType}`): ''} {status ? `- ${t(`constant.ticket_status.${status}`)}` : ''} <br/>
          </>
          {isHtmlComment ? <span className={noteColor} dangerouslySetInnerHTML={{ __html: replaceWithBr(comment) }} /> : <span className={noteColor}>{comment}</span>}
        </div>
        {isBreak && <br />}
      </React.Fragment>
    )
  })
  return (
    <div>
      <div className='animation-parent-feedbacks' style={{ maxHeight: showMore ? 'initial' : 550 }}>{noteList}</div>
      {notes?.length > 5 && (
        <a
          onClick={() => setShowMore(!showMore)}
          className='p-0'
        >
          {showMore ? 'Thu gọn' : 'Xem thêm'}
        </a>
      )}
    </div>
  )
}
